import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import getters from './getters'
import login from './modules/login'
import doctor from './modules/doctor'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    login,
    doctor
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js